import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';
import {
  ActivitiesDataScope,
  getStoreScope,
  TrackingActivitiesSelectors,
} from '@core/activities-and-notifications-data';
import type { TrackingActivity } from '@core/activities-types';
import { filterBoolean } from '@core/common-legacy';
import type { Requisition } from '@core/requisitions-types';

import { RootPageDataService } from './root-page-data.service';

@Injectable()
export class ActivityPageDataService {
  public requisition$: Observable<Requisition>;
  public activities$: Observable<TrackingActivity[]>;
  public manageCandidateAbility$: Observable<boolean>;
  public isLoaded$: Observable<boolean>;

  constructor(
    private rootData: RootPageDataService,
    private store: Store,
  ) {
    this.requisition$ = rootData.requisition$;
    const requisitionId$ = this.requisition$.pipe(map(requisition => requisition.id));
    this.activities$ = requisitionId$.pipe(
      switchMap(id => {
        const requisitionActivitiesScope = getStoreScope(ActivitiesDataScope.Requisition, id);
        return store
          .select(
            TrackingActivitiesSelectors.entities({
              scope: requisitionActivitiesScope,
            }),
          )
          .pipe(filterBoolean);
      }),
    );
    this.manageCandidateAbility$ = store.select(
      AbilitiesSelectors.hasOne(Ability.ManageCandidates),
    );
    this.isLoaded$ = requisitionId$.pipe(
      switchMap(id => store.select(TrackingActivitiesSelectors.requisitionScopeIsLoaded(id))),
    );
  }
}
